import { gql } from "@apollo/client";export default gql`mutation insert_set_collection_one($collection_id: Int, $set_id: Int, $order: Int) {
    insert_set_collection_one(
        object: { collection_id: $collection_id, set_id: $set_id, order: $order }
    ) {
        id
    }
}
`;
